import * as types from './actionTypes';  
import updateOrderApi from '../api/updateOrderApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2'

export function updateOrder(data) {
  return {
    type: types.DO_UPDATE_ORDER, 
    data
  };
}

export function doupdateOrderRes(data) {
  return {
    type: types.DO_UPDATE_ORDER_RES, 
    data
  };
}

export function update_order_details(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      updateOrderApi.updateOrder(data).then(data => {
        dispatch(doupdateOrderRes(data));
        dispatch(doupdateOrderRes(null));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
  
}